<template>
	<div style="font-family: -apple-system-font,PingFang SC,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
		<div class="carousel">
			<img src="../../assets/images/developerCommunity/dev_banner.jpg" alt="">
		</div>
		<div class="case_main">
			<div class="case_top">
				<div class="case_title">大数据分析平台的难点及突破方法</div>
				<div class="case_time">
					<span><img src="../../assets/images/developerCommunity/dev_time.png" alt="">2020/06/12</span>
					<span><img src="../../assets/images/developerCommunity/dev_people.png" alt="">Eiiplat 平台</span>
				</div>
				<hr>
			</div>
			<div class="case_detail">
				<div class="model">
					<div class="section">
						在新型制造模式下，传统的制造模式将被突破，变为“人机料法+智造系统”，数据在各个环节中按照流程顺序流动。研究与应用工业大数据，产品大数据是核心，物联大数据是实现手段，集成贯通是基础（业务模式、商业和价值驱动、关键抽取和应用）。而在实践过程中，实现这三方面都存在不同程度的难点。
					</div>
				</div>
				<div class="model">
					<div class="model_title">（1）产品大数据</div>
					<div class="section">
						产品大数据是工业大数据的根源与核心，但工业制造业领域涵盖十分广泛。行业种类繁多、产品种类数量巨大且仍在不断增长，如何规范产品大数据的定义与分类方法，建立规范的、属性明确的、可查询可追溯可定位的产品大数据，将是顺利应用工业大数据的前提。
					</div>
				</div>
				<div class="model">
					<div class="model_title">（2）物联接入设备</div>
					<div class="section">
						物联大数据是实现工业大数据畅通流动的必要手段，但在工业实际应用中，工业软件、高端物联设备不具备国产自主可控性，物联接入的高端设备的读写不开放，形成设备的信息孤岛，数据流通不畅，突破这种束缚是实现工业大数据的关键。
					</div>
				</div>
				<div class="model">
					<div class="model_title">（3）信息集成贯通</div>
					<div class="section">
						信息集成贯通是工业大数据的基础，集成贯通的难点在于商业驱动、打通关键点和环节，掌控产品源和设备，持续优化。工业大数据来源多样，且具有不同的格式和标准。有来自于各种管理系统的关系型数据，还有生产流程数据、视频监控数据等非关系型数据存储的非结构化或半结构化数据。企业内部信息系统彼此独立，在不同的信息来源之间，同类型数据也可能因为软件厂家不同、设备生产商不同等因素导致数据格式千差万别，这对实现信息集成贯通产生了巨大的挑战，实际中经常存在孤立的信息岛。
					</div>
					<div class="section">
						基于以上问题，需要规范数据格式，搭建国家、行业、企业等不同等级的工业大数据平台，打通工业大数据信息孤岛，充分挖掘工业大数据价值。建设工业大数据不同等级平台作为发展工业大数据的必由之路，既是难点更是需要解决和突破的重点。
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
	export default {
		name: 'DeveloperDsjDetail',
		data() {
			return {
				detailId: this.$route.params.id,
			}
		},
		mounted() {
			window.scrollTo(0, 0)
			this.init()
		},
		methods: {
			init() {
				console.log(this.detailId)
			}
		}
	}
</script>

<style lang="scss">
.carousel {
		img {
			width: 100%;
		}
	}

	.case_main {
		padding: 0 2.4rem;
		margin-bottom: 0.3rem;
		.case_top{
			margin-top: 0.6rem;
			.case_title{
				font-size: 0.4rem;
			}
			.case_time {
				display: flex;
				span {
					font-size: 0.18rem;
					color: #999;
					margin-right: 0.35rem;
					display: flex;
					align-items: center;
				}

				img {
					width: 0.2rem;
					height: 0.2rem;
					margin-right: 0.1rem;
				}
			}
			hr{
				margin: 0.4rem 0;
				color: #cccccc;
			}
		}
		.case_detail{
			margin: 0 2.2rem;
			margin-bottom: 0.6rem;
			color: #000000;
			img {
				width: 100%;
			}
			.model{
				margin-top: 0.2rem;
				.model_title{
					font-size: 0.22rem;
					font-weight: 600;
				}
				.section{
					padding-left: 0.12rem;
					text-indent: 2em;
					line-height: 0.36rem;
					font-size: 0.18rem;
					margin-top: 0.12rem;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/DeveloperDsjDetail.vue